import { monthNames } from '../../constants/constants';

export const dateFunction = (d) => `${new Date(d).toLocaleString('es-MX', { timeZone: 'America/Mexico_City' })}`;
export const simpleDateFunction = (d) => `${new Date(d).toLocaleDateString('es-MX', { timeZone: 'America/Mexico_City' })}`;
export { dateFunction as default };
